<template>
  <button v-bind:class="btnClass" :disabled="disabled" class="text-gra">{{ text }}</button>
</template>

<script>
export default {
  name: 'AppBtn',
  props: {
    text: {},
    disabled: {
      default: false,
    }
  },
  computed: {
    btnClass () {
      let d = {
        'bg-tus': !this.disabled,
        'bg-gray-100': this.disabled,
        'text-white': !this.disabled,
        'text-gray-300': this.disabled,
        'font-bold': true,
        'py-4': true,
        'px-4': true,
        'w-full': true,
        'md:w-auto': true,
        'md:pr-20': true,
        'md:pl-20': true,
        'rounded': true,
        'uppercase': true
      }
      return d
    }
  }
}
</script>

<style scoped>

</style>
